import React, { useState } from "react";
import api, { apiErrorMessage } from "../lib/api";

export function PharmacyInvoice({ order, canAttach = false, refresh }) {
  const [file, setFile] = useState(null);
  const [number, setNumber] = useState("");
  const [issuedOn, setIssuedOn] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const paid = ["paid", "refund_pending", "refunded"].includes(order.payment_status);
  const attach = async (event) => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError("");
    try {
      const payload = new FormData();
      payload.append("file", file); payload.append("invoice_number", number.trim());
      payload.append("issued_on", issuedOn); payload.append("amount_minor", order.total_minor);
      payload.append("expected_version", order.version);
      await api.post(`/v1/pharmacy/orders/${order.order_id}/invoice`, payload);
      await refresh?.();
    } catch (e) { setError(apiErrorMessage(e, "Invoice upload could not be confirmed. Refresh before uploading again.")); }
    finally { setBusy(false); }
  };
  const download = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.get(`/v1/pharmacy/orders/${order.order_id}/invoice`, { responseType: "blob" });
      const url = URL.createObjectURL(data); const link = document.createElement("a");
      link.href = url; link.download = `${order.order_id}-invoice.pdf`; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) { setError(apiErrorMessage(e, "Invoice could not be downloaded.")); }
    finally { setBusy(false); }
  };
  return <section className="mt-4 rounded-xl border p-4" aria-label="Pharmacy invoice">
    <h3 className="font-semibold">Pharmacy invoice</h3>
    <p className="text-sm mt-1">The payment receipt records money received. The pharmacy issues and supplies its invoice separately.</p>
    {order.invoice ? <div className="mt-3 text-sm">
      <p>Invoice {order.invoice.invoice_number} · Issued {order.invoice.issued_on}</p>
      <button type="button" className="mg-btn-secondary mt-2" disabled={busy} onClick={download}>Download pharmacy invoice</button>
    </div> : <p className="text-sm mt-2">Invoice not yet attached. Contact the pharmacy for your invoice.</p>}
    {canAttach && paid && !order.invoice && <form className="space-y-3 mt-3" onSubmit={attach}>
      <p className="text-xs">Upload the pharmacy-issued PDF that matches this order total. Check its details first; attached originals cannot be overwritten.</p>
      <label className="block text-sm">Invoice number<input className="mg-input" value={number} onChange={e => setNumber(e.target.value)} required maxLength={100} /></label>
      <label className="block text-sm">Invoice issue date<input className="mg-input" type="date" value={issuedOn} onChange={e => setIssuedOn(e.target.value)} required /></label>
      <label className="block text-sm">Issued invoice PDF<input className="mg-input" type="file" accept="application/pdf" required onChange={e => setFile(e.target.files?.[0] || null)} /></label>
      <button className="mg-btn-primary" disabled={busy || !file || !number.trim() || !issuedOn}>{busy ? "Attaching…" : "Attach issued invoice"}</button>
    </form>}
    {error && <p role="alert" className="mt-2 text-red-700">{error}</p>}
  </section>;
}
